@if (item) {
  <div class="item-details-preview" @fadeInOut [ngClass]="{ 'mt-3 mb-3 ps-3' : viewConfig === 'relationship-sort-list'}">
    @if (viewConfig === 'relationship-sort-list') {
      <div class="top-header">
        <div class="drag-handle text-muted float-start pe-1" [class.invisible]="pendingChanges">
          <i class="fas fa-grip-vertical fa-fw"></i>
        </div>
        <ds-type-badge [object]="item"></ds-type-badge>
      </div>
    } @else {
      <ds-type-badge [object]="item"></ds-type-badge>
    }
    <ds-truncatable [id]="item.id">
      <h3 [innerHTML]="item.firstMetadataValue('dc.title') || ('mydspace.results.no-title' | translate)" [ngClass]="{'lead': true,'text-muted': !item.firstMetadataValue('dc.title')}"></h3>
      <div>
        <span class="text-muted">
          <ds-truncatable-part [id]="item.id" [minLines]="1">
            (@if (item.hasMetadata('dc.publisher')) {
            <span class="item-list-publisher"
            [innerHTML]="item.firstMetadataValue('dc.publisher') + ', '"></span>
          }
          <span class="item-list-date" [innerHTML]="item.firstMetadataValue('dc.date.issued') || ('mydspace.results.no-date' | translate)"></span>)
          @if (item.hasMetadata(authorMetadata);) {
            <span
              class="item-list-authors">
              @if (item.allMetadata(authorMetadata).length === 0) {
                <span>{{'mydspace.results.no-authors' | translate}}</span>
              }
              <span class="d-flex w-100">
                @for (author of item.allMetadata(authorMetadata); track author; let i = $index; let last = $last) {
                  <span class="metadata-content">
                    <ds-metadata-link-view [item]="item" [metadataName]="authorMetadata"
                    [metadata]="author"></ds-metadata-link-view>@if (!last) {
                    <span
                    >; </span>
                  }
                </span>
              }
            </span>
          </span>
        }
      </ds-truncatable-part>
    </span>
    <ds-truncatable-part [id]="item.id" [minLines]="1" class="item-list-abstract">
      <span [ngClass]="{'text-muted': !item.firstMetadataValue('dc.description.abstract')}"
      [innerHTML]="(item.firstMetadataValue('dc.description.abstract')) || ('mydspace.results.no-abstract' | translate)"></span>
    </ds-truncatable-part>
  </div>
</ds-truncatable>
@if (showSubmitter) {
  <ds-item-submitter [object]="item"></ds-item-submitter>
}
@if (viewConfig === 'relationship-sort-list') {
  <div class="d-flex justify-content-end me-3">
    <button class="btn btn-danger btn-sm"
      [dsBtnDisabled]="processing || pendingChanges"
      (click)="dispatchDelete()">
      @if (processing) {
        <span><i class='fas fa-circle-notch fa-spin'></i> {{'loading.default' | translate}}</span>
      }
      @if (!processing) {
        <span> {{"manage.relationships.unselect" | translate}}</span>
      }
    </button>
  </div>
}
</div>
}
